// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'opportunity-refresh';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M5.832 11.952 3.24 7.488h3.744m5.472 3.96-.36.576M7.344 2.808H.576l2.736 4.68m8.856 4.536L9 17.496l-3.168-5.472zm2.448-7.632h2.808V1.08' />
    <path d='M17.28 4.392c-.648-2.376-3.096-3.888-5.472-3.24-2.376.648-3.888 3.096-3.24 5.472s3.096 3.888 5.472 3.24a4.13 4.13 0 0 0 2.376-1.584' />
  </g>
);

export const viewBox = '0 0 18 18';
